import { render, staticRenderFns } from "./FeedbackPanel.vue?vue&type=template&id=50454bde&scoped=true&"
import script from "./FeedbackPanel.vue?vue&type=script&lang=js&"
export * from "./FeedbackPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPanel.vue?vue&type=style&index=0&id=50454bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50454bde",
  null
  
)

export default component.exports